import { toast } from "sonner";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useAuth } from "@/context/AuthContext";
import { errorMessage } from "@/lib/api";
import { ROLE_LABELS } from "@/lib/labels";

export const SchoolSwitcher = () => {
  const { me, switchSchool } = useAuth();
  const active = me?.active_school;
  if (!active) return null;
  if (me.memberships.length < 2) {
    return (
      <div className="truncate" data-testid="active-school-name">
        <p className="text-sm font-bold truncate">{active.school_name}</p>
        <p className="text-xs text-muted-foreground">{ROLE_LABELS[active.role]}</p>
      </div>
    );
  }
  const change = async (id) => {
    try {
      await switchSchool(id);
      toast.success("Sekolah aktif diganti.");
    } catch (e) {
      toast.error(errorMessage(e));
    }
  };
  return (
    <Select value={active.school_id} onValueChange={change}>
      <SelectTrigger className="max-w-xs" aria-label="Pilih sekolah aktif" data-testid="school-switcher">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {me.memberships.map((m) => (
          <SelectItem key={m.school_id} value={m.school_id}>{m.school_name} · {ROLE_LABELS[m.role]}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
